import { useDispatch } from "react-redux";
import { useLazyGetJobsStatusesQuery } from "../../../Store/Builder/jobs.api";
import { setLoader } from "../../../Store/Slice/techsbookSlice";
import showToast from "../../Hooks/toast";
import { setJobStatuses } from "../../../Store/Slice/jobsSlice";

const useGetJobsStatuses = () => {
  const dispatch = useDispatch();
  const [getStatuses] = useLazyGetJobsStatusesQuery();

  const get = () => {
    dispatch(setLoader(true));
    getStatuses()
      .unwrap()
      .then((res) => {
        let array = [
          {
            name: 'All',
            id: 'all',
            active: true,
          }
        ];
        for (let key in res) {
          array = [
            ...array,
            {
              name: res[key],
              id: key,
              active: false,
            },
          ];
        }
        dispatch(setLoader(false));
        dispatch(setJobStatuses(array));
      })
      .catch((err) => {
        dispatch(setLoader(false));
        showToast(err?.data?.message ?? "Error", "error");
      });
  };

  return {
    get,
  };
};

export default useGetJobsStatuses;
